import React, { useState } from "react";
import HeaderSegment from "../HeaderSegment";
import { segmentData } from "components/Connect/helper";
import ContentCard from "../ContentCard";
import ChatCard from "./components/ChatCard";
import { useChatThreads } from "hooks/api/useChatThreads";
import EmptyState from "components/BaseWidgets/emptyState";

function Chats({ profileFilters = [], searchFilter = null }) {
  const [searchText, setSearchText] = useState("");
  const [segment, setSegment] = useState("all");

  // segment affects searchFilter if user changes segment
  const segmentSearchType =
    segment === "unread" ? 1 : segment === "favourite" ? 2 : undefined;

  const finalSearchType = segmentSearchType ?? searchFilter;
  
  const { data, isLoading, error } = useChatThreads({
    search: searchText || "",
    type: finalSearchType,
    list_type:
      Array.isArray(profileFilters) && profileFilters.length > 0
        ? profileFilters
        : undefined,
    page: 1,
    limit: 50,
  });

  const chatList = data?.chat_data || [];

  const filteredChats =
    segment === "unread"
      ? chatList.filter((chat) => chat.unread_count > 0)
      : chatList;

  return (
    <div className="flex flex-col gap-6">
      <HeaderSegment
        data={segmentData.chats}
        onChange={(value) => setSegment(value)}
      />

      <ContentCard onSearch={setSearchText}>
        <div className="flex flex-col gap-2">
          {isLoading && <div className="no-results">Loading chats...</div>}
          {error && <div className="no-results">Failed to load chats</div>}
          {!isLoading && filteredChats.length === 0 && (
            <EmptyState/>
          )}
          {!isLoading &&
            filteredChats.map((chat, index) => (
              <ChatCard key={index} currentUserId={chat?.aec_id} data={chat} />
            ))}
        </div>
      </ContentCard>
    </div>
  );
}

export default Chats;
